import React from "react";
import { VaultManager } from "./components/VaultManager";
import { LoginPage } from "./components/LoginPage";
import { LoadingScreen } from "./components/LoadingScreen";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/ui/theme-provider";
import "./index.css";

function AuthenticatedApp() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <VaultManager />;
}

export function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <AuthProvider>
        <div className="min-h-screen w-full bg-background">
          <AuthenticatedApp />
          <Toaster
            position="top-right"
            richColors
            closeButton
            duration={4000}
          />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
